export default function Unauthorized() {
  return (
    <div>
      <p style={{ fontSize: 16 }}>You are not allowed to view here.</p>
    </div>
  );
}
